import { render, staticRenderFns } from "./InstructorDashboard.vue?vue&type=template&id=6b04055c&scoped=true&"
import script from "./InstructorDashboard.vue?vue&type=script&lang=js&"
export * from "./InstructorDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InstructorDashboard.vue?vue&type=style&index=0&id=6b04055c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b04055c",
  null
  
)

export default component.exports